/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Organizerpagetitle2Inputs */

const en_organizerpagetitle2 = /** @type {(inputs: Organizerpagetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your profile`)
};

const de_organizerpagetitle2 = /** @type {(inputs: Organizerpagetitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Profil`)
};

/**
* | output |
* | --- |
* | "Your profile" |
*
* @param {Organizerpagetitle2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const organizerpagetitle2 = /** @type {((inputs?: Organizerpagetitle2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Organizerpagetitle2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_organizerpagetitle2(inputs)
	return de_organizerpagetitle2(inputs)
});
export { organizerpagetitle2 as "organizerPageTitle" }